// extracted by mini-css-extract-plugin
export default {"root":"Faq_root__iZVCQ"};